export default __webpack_public_path__ + "static/media/list-ol.0f30d50c.svg";